<template>
    <div class="wrapper">
        <img class="image-size" src="../../assets/img/mobile/home_image_1.jpg"/>
        <img class="image-size" src="../../assets/img/mobile/home_image_2.jpg"/>
        <img class="image-size" src="../../assets/img/mobile/home_image_3.jpg"/>
        <img class="image-size" src="../../assets/img/mobile/home_perview_title.jpg"/>
        <div class="preview-container">
            <div class="show-menu flex">
                <div v-for="(item,index) in showMenus"
                     :key="index" :class="{active:cur_show === item.value}" class="show-item flex flex-direction align-center justify-center"
                     @click="cur_show = item.value">
                    <div class="title">{{ item.label }}</div>
                </div>
            </div>
            <div class="flex align-center justify-center">
                <div class="flex flex-direction align-center">
                    <div class="pc-title self-end">PC端 {{ showMenus[cur_show].label }}</div>
                    <img :src="shows[cur_show].pc" class="pc-image"/>
                </div>
            </div>
        </div>
        <img class="image-size" src="../../assets/img/mobile/home_image_4.jpg"/>
        <img class="image-size" src="../../assets/img/mobile/home_image_5.jpg"/>
        <img class="image-size" src="../../assets/img/mobile/home_image_6.jpg"/>
        <img class="image-size" src="../../assets/img/mobile/home_image_7.jpg"/>
        <img class="image-size" src="../../assets/img/mobile/home_image_8.jpg"/>
    </div>
</template>

<script>

import {organizMenus} from "@/utils/const";

export default {
    name: "home",
    data() {
        return {
            showMenus: organizMenus,
            cur_show: 0,
            shows: [{
                pc: require('@/assets/img/img_shows_pc_1.png'),
            }, {
                pc: require('@/assets/img/img_shows_pc_2.png'),
            }, {
                pc: require('@/assets/img/img_shows_pc_3.png'),
            }, {
                pc: require('@/assets/img/img_shows_pc_4.png'),
            }, {
                pc: require('@/assets/img/img_shows_pc_5.png'),
            }, {
                pc: require('@/assets/img/img_shows_pc_6.png'),
            }, {
                pc: require('@/assets/img/img_shows_pc_7.png'),
            }, {
                pc: require('@/assets/img/img_shows_pc_8.png'),
            }],
        }
    },
    created() {
    },
    components: {},
    methods: {},
    filters: {},
    watch: {},
}
</script>

<style lang="scss" scoped>
.wrapper {
    .image-size {
        width: 100%;
    }

    .preview-container {
        background: #0a2240;
        .pc-title{
            font-size: 0.63rem;
            color: #ffffff;
            margin-top: 1rem;
        }
        .pc-image{
            width: 92vw;
            height: 53.07vw;
            background-color: #e2e6ec;
            border-radius: 0.31rem;
            padding: 0.1rem;
            margin-bottom: 2rem;
            margin-top: 0.5rem;
        }
        .show-menu {
            overflow: scroll;
            height: 9.33vw;

            &::-webkit-scrollbar {
                display: none;
            }

            .show-item {
                font-size: .8rem;
                color: #d0def1;
                width: 4rem;
                flex-shrink: 0;
                height: 9.33vw;
                position: relative;
                &:after{
                    position: absolute;
                    content: '';
                    width: 101%;
                    height: 0.3vw;
                    background-color: #89a0bf;
                    border-radius: 0.2vw;
                    left: 0;
                    bottom: 0;
                    z-index: 1;
                }
                &.active {
                    color: #ff9700;

                    &:before{
                        position: absolute;
                        content: '';
                        width: 11.33vw;
                        height: 0.6vw;
                        background-color: #ff9700;
                        border-radius: 0.2vw;
                        left: 50%;
                        bottom: -0.1vw;
                        z-index: 99;
                        transform: translateX(-50%);
                    }
                }
            }
        }

    }
}
</style>